import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function formatErr(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return String(detail);
}

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register(name, email, password);
      navigate("/");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <div className="text-center mb-10">
        <div className="font-serif text-3xl text-stone-900">Crea tu cuenta</div>
        <p className="text-stone-500 mt-2">Únete a Luxe Aroma Scents</p>
      </div>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <label className="label-caps text-stone-500 block mb-2">Nombre completo</label>
          <input required value={name} onChange={(e) => setName(e.target.value)} className="w-full border border-stone-300 px-4 py-3 outline-none focus:border-[#3F4E4F]" data-testid="register-name-input" />
        </div>
        <div>
          <label className="label-caps text-stone-500 block mb-2">Correo electrónico</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-stone-300 px-4 py-3 outline-none focus:border-[#3F4E4F]" data-testid="register-email-input" />
        </div>
        <div>
          <label className="label-caps text-stone-500 block mb-2">Contraseña (mín. 6 caracteres)</label>
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-stone-300 px-4 py-3 outline-none focus:border-[#3F4E4F]" data-testid="register-password-input" />
        </div>
        {error && <div className="text-[#991B1B] text-sm" data-testid="register-error">{error}</div>}
        <button type="submit" disabled={loading} className="w-full bg-[#3F4E4F] text-white py-4 hover:bg-[#2C3637] transition-colors disabled:opacity-50" data-testid="register-submit-button">
          {loading ? "Creando cuenta..." : "Crear cuenta"}
        </button>
      </form>
      <p className="text-center text-sm text-stone-500 mt-6">
        ¿Ya tienes cuenta? <Link to="/login" className="text-[#3F4E4F] font-medium hover:underline" data-testid="go-login-link">Inicia sesión</Link>
      </p>
    </div>
  );
}
